/**
 * ****************************************************************************
 * @description     :   Route for chats app
 * @created at      :   2022/05/18
 * @created by      :   ANS874 – quanhvm@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const ra001500v = () => import('@/views/inquiry/ra001500v');
const ra200800v = () => import('@/views/inquiry/ra200800v');
const ra002500v = () => import('@/views/inquiry/ra002500v');
const ra002600v = () => import('@/views/inquiry/ra002600v');
const ra002700v = () => import('@/views/inquiry/ra002700v');
const ra300600v = () => import('@/views/inquiry/ra300600v');
const ra003500v = () => import('@/views/inquiry/ra003500v');
/**
 * Defined Router
 */
export default [
    {
        path: '/inquiry/ra001500v',
        name: 'ra001500v',
        component: ra001500v,
        meta: {
            title: 'ＦＣポータル'
        }
    },
    {
        path: '/inquiry/ra200800v',
        name: 'ra200800v',
        component: ra200800v,
        meta: {
            title: '1次会社ポータル',
            isClientPage: true
        }
    },
    {
        path: '/inquiry/ra002500v',
        name: 'ra002500v',
        component: ra002500v,
        meta: {
            title: '作業日毎情報の照会'
        }
    },
    {
        path: '/inquiry/ra002600v',
        name: 'ra002600v',
        component: ra002600v,
        meta: {
            title: '物件情報の検索'
        }
    },
    {
        path: '/inquiry/ra002700v',
        name: 'ra002700v',
        component: ra002700v,
        meta: {
            title: '物件受領状況の照会'
        }
    },
    {
        path: '/mobile/ra300600v',
        name: 'ra300600v',
        component: ra300600v,
        meta: {
            title: '新規入場事前登録一覧',
            isIsMobile: true
        }
    },
    {
        path: '/inquiry/ra003500v',
        name: 'ra003500v',
        component: ra003500v,
        meta: {
            title: '１次会社代行入力の選択'
        }
    }
];
